import React, { useState } from 'react';
import PropTypes from 'prop-types';

// O-5024: module scope on purpose. Declaring this inside a dropdown's render
// body makes it a NEW component type on every render, so React unmounts and
// remounts it — throwing away its hover state mid-interaction. Shared by both
// event-template dropdowns.
const baseStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 16px',
  cursor: 'pointer',
  borderRadius: '6px',
  margin: '1px 6px',
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: '600',
  fontSize: '14px',
  lineHeight: '20px',
  color: 'var(--bk-c-414651, #414651)',
  textDecoration: 'none'
};

const iconStyle = {
  width: '16px',
  fontSize: '14px',
  color: 'var(--bk-c-717680, #717680)'
};

const TemplateMenuItem = ({ icon, label, subtitle, onClick, disabled, destructive, testId }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href="#"
      role="menuitem"
      style={{
        ...baseStyle,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '2px',
        ...(destructive ? { color: 'var(--bk-c-d92d20, #D92D20)' } : {}),
        ...(hovered && !disabled ? { backgroundColor: 'var(--bk-c-f5f5f5, #F5F5F5)' } : {}),
        ...(disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {})
      }}
      aria-disabled={disabled || undefined}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={(e) => {
        e.preventDefault();
        if (!disabled) onClick();
      }}
      data-testid={testId}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {icon && <i className={icon} style={iconStyle} aria-hidden="true" />}
        <span>{label}</span>
      </div>
      {subtitle && (
        <span style={{
          fontSize: '13px',
          fontWeight: '400',
          color: 'var(--bk-c-717680, #717680)',
          marginLeft: icon ? '24px' : '0'
        }}>
          {subtitle}
        </span>
      )}
    </a>
  );
};

TemplateMenuItem.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  destructive: PropTypes.bool,
  testId: PropTypes.string
};

TemplateMenuItem.defaultProps = {
  icon: null,
  subtitle: null,
  disabled: false,
  destructive: false,
  testId: undefined
};

export default TemplateMenuItem;
